import { render, staticRenderFns } from "./DynamicChoicesInput.vue?vue&type=template&id=63b9912b"
import script from "./DynamicChoicesInput.vue?vue&type=script&lang=js"
export * from "./DynamicChoicesInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports